import { Box, Divider, Heading, Icon, Modal, Paragraph } from '@zillow/constellation-10';
import { IconTagDollarSignFilled } from '@zillow/constellation-icons';

import ModalFooter from '../ModalFooter';

type Props = {
  onClose: ({ triggerSource }: { triggerSource: string }) => void;
  onSubmit: () => void;
  onCancelDataEventId: string;
  onSubmitDataEventId: string;
};

/**
 * NOTE: `onSubmit` is called by `cancelButton` while
 * `onClose` is called by `submitButton` and `closeButton`
 */
const MFTotalMonthlyPriceWithFeeAcknowledgementModal = ({
  onClose,
  onSubmit,
  onCancelDataEventId,
  onSubmitDataEventId,
}: Props) => {
  return (
    <Modal.Root
      open={true}
      onOpenChange={(open) => !open && onClose({ triggerSource: 'button_x_to_close' })}
      size={{ base: 'fullScreen', md: 'md' }}
    >
      <Modal.Portal>
        <Modal.Backdrop>
          <Modal.Content>
            <Modal.Body>
              <div data-testid="MFTotalMonthlyPriceWithFeeAcknowledgementModal">
                <Box css={{ marginBottom: '600' }}>
                  <Icon
                    role="img"
                    size="xl"
                    css={{
                      color: 'icon.subtle',
                    }}
                  >
                    <IconTagDollarSignFilled />
                  </Icon>
                </Box>

                <Heading level={2} textStyle="body-lg-bold" css={{ marginBottom: '400' }}>
                  You&apos;re showing required monthly fees in the total monthly price
                </Heading>

                <div>
                  <Paragraph>
                    If you&apos;ve already added costs and fees, the floor plan prices on your listing will be updated
                    and labeled as the &ldquo;total monthly price.&rdquo; We recommend double checking that all
                    information is accurate by visiting the &ldquo;costs and fees breakdown.&rdquo;
                  </Paragraph>
                </div>
              </div>
            </Modal.Body>
            <Divider />
            <Modal.Footer>
              <ModalFooter
                cancelText="Add relevant fees"
                onCancel={onSubmit}
                submitText="OK"
                onSubmit={() => {
                  onClose({ triggerSource: 'button_okay' });
                }}
                onCancelDataEventId={onSubmitDataEventId}
                onSubmitDataEventId={onCancelDataEventId}
              />
            </Modal.Footer>
            <Modal.CloseButton />
          </Modal.Content>
        </Modal.Backdrop>
      </Modal.Portal>
    </Modal.Root>
  );
};

export default MFTotalMonthlyPriceWithFeeAcknowledgementModal;
